/**
 * Mobile may persist multiple photos in one actualValue (comma-joined data URIs).
 * Production splits on repeated `data` prefixes — required for EMERGENCY_PHOTOS etc.
 */
export function normalizeBase64Images(base64: string): string[] {
  const parts = base64.split('data');
  const normalizedImages: string[] = [];

  for (let i = 1; i < parts.length; i++) {
    const part = parts[i];
    if (part) {
      const normalized = part.endsWith(',') ? part.slice(0, -1) : part;
      normalizedImages.push(`data${normalized}`);
    }
  }

  return normalizedImages;
}

export function parseCheckpointImageSources(
  actualValue: string | string[] | null | undefined,
  actualValues?: string[] | null,
): string[] {
  if (actualValues?.length) {
    return actualValues.filter(Boolean);
  }

  if (Array.isArray(actualValue)) {
    return actualValue.filter(Boolean);
  }

  if (!actualValue?.trim()) {
    return [];
  }

  const fromBase64 = normalizeBase64Images(actualValue);
  if (fromBase64.length > 0) {
    return fromBase64;
  }

  if (actualValue.includes(',')) {
    return actualValue
      .split(',')
      .map(value => value.trim())
      .filter(Boolean);
  }

  return [actualValue];
}
